import { each, filter, find } from "lodash";
import { PeriodRange } from "@linkfluence/models/date";
import { Clause } from "@radarly/models/clause";
import { getFieldFromInnerClause } from "@radarly/models/clause/getter";
import { isNotClause, isTermClause } from "@radarly/models/clause/is";
import { FullFacet } from "@radarly/models/facets";
import { useFacetValues } from "./useFacetValues";

function getValuesFromClause(clause: Clause) {
  const values: FullFacet["values"] = [];
  each(clause.and, (innerClause) => {
    const field = getFieldFromInnerClause(innerClause);
    if (isNotClause(innerClause)) {
      each(innerClause.not[field], (value) => {
        values.push({
          id: value,
          label: value,
        });
      });
    } else if (isTermClause(innerClause)) {
      each(innerClause[field], (value) => {
        values.push({
          id: value,
          label: "" + value,
        });
      });
    }
  });
  return values;
}

function mergeLazyValuesAndClauseValues(
  clause: Clause,
  values: FullFacet["values"]
) {
  const clauseValues = getValuesFromClause(clause);
  return [
    ...filter(clauseValues, (value) => !find(values, { id: value.id })),
    ...(values || []),
  ];
}

export function useFacetValuesFromClause(
  project: number,
  clause: Clause,
  facet: FullFacet,
  period: PeriodRange
) {
  const { loading, values, error } = useFacetValues(project, facet);
  return {
    loading,
    values: loading ? [] : mergeLazyValuesAndClauseValues(clause, values),
    order: getValuesFromClause(clause),
    error: values?.length < 1 || error,
  };
}
